import { ShadowCard } from '../../../CommonNestedStyles/FormWrapper.style';
import { Accordion } from 'src/components/base/core/OtherUtilities/Accordions/Accordion/Accordion';
import { FaqContent, AccordianWrapper } from './FaqList.style';
import { useGetAllFaqsQuery } from '../../../../../../services/account/supportServiceApi';
import { sanitizeFaqHtml } from './sanitizeFaqHtml';
export const FaqList = () => {
  const { data } = useGetAllFaqsQuery('');
  return (
    <ShadowCard paddingX={4} paddingY={6} marginBottom={6}>
      <AccordianWrapper>
        {data?.map((item: any) => {
          return (
            <Accordion title={item?.title}>
              <FaqContent
                dangerouslySetInnerHTML={{ __html: sanitizeFaqHtml(item?.body) }}
              ></FaqContent>
            </Accordion>
          );
        })}
      </AccordianWrapper>
    </ShadowCard>
  );
};
